export const registerDemoUrl = '/register/demo';
export const registerLiveUrl = '/register/live';